<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadSummaryModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
        <span :class="{'col-width': isMobile}">
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ leadHeader | capitalize }}</b></span>

          </span>
        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>

      <LeadInfo
        class="mb-5"
        :selectedLead="selectedLead"
        @openPrivacyPolicyModal="openPrivacyPolicyModal"/>

      <hr class="separator-lead-details">

      <FollowUp
        :pursues="selectedLead.pursues"
        :selected-lead-id="selectedLead.id"
        :selectedLead="selectedLead"
        :lead-status="selectedLead.status"
        :service="service"
        @createdPursue="createdPursue"
        @deletedPursue="deletedPursue"
      />

      <!--<hr class="separator-lead-details">-->
    </va-modal>

    <PrivacyPolicyModal
      v-if="showPrivacyPolicyModal && (selectedLead.privacyPolicy || selectedLead.consentId)"
      :url="handlePrivacyUrl(selectedLead)"
      :is-consent-url="selectedLead.consentId !== null && selectedLead.consentId !== ''"
      @cancel="onCancelPrivacyPolicyModal"
    />

    </div>
</template>
<script>

import LeadInfo from '@/components/wellbeing/leads/LeadInfo'
import PrivacyPolicyModal from '@/components/leads/PrivacyPolicyModal'
import FollowUp from "@/components/wellbeing/leads/FollowUp";
export default {
  components: {
    FollowUp,
    PrivacyPolicyModal,
    LeadInfo

  },
  props: {
    selectedLead: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      showPrivacyPolicyModal: false
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    createdPursue (data) {
      this.selectedLead.pursues.push(data.newPursue)
      this.selectedLead.status = data.newPursue.status
    },
    deletedPursue (data) {
      this.selectedLead.status = data.leadStatus
      this.selectedLead.pursues = this.selectedLead.pursues.filter(pursue => {
        return pursue.id !== data.pursueToDelete.id
      })
    },
    handlePrivacyUrl: function (selectedLead) {
      if((selectedLead.consentId !== null && selectedLead.consentId !== '') && process.env.VUE_APP_CONSENT_URL) {
        return `${process.env.VUE_APP_CONSENT_URL}v1/consent/${selectedLead.consentId}`
      }
      return selectedLead.privacy_policy
    },
    openPrivacyPolicyModal: function () {
      this.showModal = false
      this.showPrivacyPolicyModal = true
    },
    onCancelPrivacyPolicyModal: function () {
      this.showPrivacyPolicyModal = false
      this.showModal = true
    },
  },
  computed: {
    isMobile: function () {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches
    },
    leadHeader: function () {
      let header = ''
      if (this.selectedLead && this.selectedLead.title && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.title + ' ' + this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name && this.selectedLead.surname) {
        header = this.selectedLead.name + ' ' + this.selectedLead.surname
      } else if (this.selectedLead && this.selectedLead.name) {
        header = this.selectedLead.name
      }
      return header
    },
  }
}
</script>
